import { Table } from 'antd'
import { createContext, FC, useMemo } from 'react'
import PrintQueueTableWrapper from '../../../../components/print-queue-table/print-queue-table-wrapper'
import { useHasRole } from '../../../../hooks/use-has-role'
import { useGetPrintQueueEntriesQuery } from '../../../../store/api/print-queue-entries-api'
import Machine from '../../../../types/api/machine'
import { NOTE_EDIT_ROLES } from './constants/note-edit-roles'
import { getColumns } from './columns'
import PrintQueueEntry from '../../../../types/api/print-queue-entry'
import { getQueryParams } from './helpers/get-query-params'
import { getPrintQueueEntryRowClassName } from './helpers/print-job-helpers'

export const OneMachineScheduleContext = createContext<PrintQueueEntry[]>([])

interface OneMachineScheduleProps {
    machine: Machine
}

const OneMachineSchedule: FC<OneMachineScheduleProps> = ({ machine }) => {
    const queryParams = getQueryParams(machine)
    const { data } = useGetPrintQueueEntriesQuery(queryParams, {
        pollingInterval: 5000,
        skipPollingIfUnfocused: true,
    })
    const dataSource = data?.data || []

    const canEditNote = useHasRole(NOTE_EDIT_ROLES)
    const isRgMachine = machine.machine_brand?.name === 'RG'
    const columns = useMemo(
        () => getColumns(canEditNote, isRgMachine),
        [canEditNote, isRgMachine]
    )

    return (
        <OneMachineScheduleContext.Provider value={dataSource}>
            <PrintQueueTableWrapper
                style={{ flex: 'auto', height: '100%', width: '100%' }}
                tableHasNotPagination
            >
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    rowKey={'documentId'}
                    size={'small'}
                    rowClassName={getPrintQueueEntryRowClassName}
                />
            </PrintQueueTableWrapper>
        </OneMachineScheduleContext.Provider>
    )
}

export default OneMachineSchedule
